<template>
  <crud-form
    v-model="payload"
    :page-title="$t('app.parameters.extension.title')"
    :request-class="requestClass"
    :total-group="1"
    navigate-back-route="Parameters"
    navigate-page-after-save="ExtensionParameters"
  >
    <template slot="group-1">
      <v-flex>
        <table
          class="v-datatable v-table theme--light parameter-table"
        >
          <thead>
            <tr>
              <th
                class="column text-xs-left"
              >
                <span>{{ $t('app.parameters.headers.parameters') }}</span>
                <span
                  data-v-02776ea6
                  class="v-tooltip v-tooltip--bottom"
                />
              </th>
              <th
                role="columnheader"
                scope="col"
                aria-label="TESTEESTE"
                class="column text-xs-left"
              >
                <span>{{ $t('app.parameters.headers.value') }}</span>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td
                width="30%"
                style="height: 103px"
                class="text-body-small-regular"
              >
                {{ $t('app.parameters.extension.form.feePercentage') }}
              </td>
              <td>
                <v-layout
                  align="center"
                  justify="end"
                  wrap
                >
                  <v-flex
                    xs12
                    md2
                  >
                    <input-percentage
                      id="porcentagemDeJuros"
                      v-model="payload.porcentagemDeJuros"
                      required
                      style="width: 136px"
                      maxlength="6"
                      :decimals="2"
                      return-masked-value
                      :rules="[minValue(1),maxValue(100)]"
                      :loading="loading"
                      :label="$t('app.parameters.extension.form.feePercentageLabel')"
                      separator="."
                    />
                  </v-flex>
                </v-layout>
              </td>
            </tr>
            <tr>
              <td
                width="30%"
                style="height: 103px"
                class="text-body-small-regular"
              >
                {{ $t('app.parameters.extension.form.overdueFinePercentage') }}
              </td>
              <td>
                <input-percentage
                  id="porcentagemDeMultaPorAtraso"
                  v-model="payload.porcentagemDeMultaPorAtraso"
                  style="width: 136px"
                  maxlength="6"
                  :decimals="2"
                  return-masked-value
                  :rules="[minValue(1),maxValue(100)]"
                  :loading="loading"
                  :label="$t('app.parameters.extension.form.overdueFinePercentageLabel')"
                  separator="."
                  required
                />
              </td>
            </tr>
          </tbody>
        </table>
      </v-flex>
    </template>
  </crud-form>
</template>

<script>
import ExtensionParametersRequest from 'Domain/parameters/ExtensionParametersRequest';
import CrudForm from 'Support/components/crud/CrudForm.vue';
import RulesMixin from 'Support/mixins/rules-mixin';
import InputPercentage from 'Support/components/inputs/InputPercentage.vue';

export default {
  name: 'ExtensionParametersForm',
  components: {
    CrudForm,
    InputPercentage,
  },
  mixins: [RulesMixin],
  data: () => ({
    requestClass: ExtensionParametersRequest,
    payload: {
      porcentagemDeJuros: '',
      porcentagemDeMultaPorAtraso: '',
    },
    loading: false,
  }),
  methods: {
    minValue(comparison) {
      return (value) => {
        if (!comparison || !value) return true;
        const floatValue = this.parseValueToFloat(`${value}`);
        if (floatValue < comparison) {
          return this.$t('support.components.inputs.mustBeBiggerThan',
            { num: comparison - 1 });
        }
        return true;
      };
    },
    maxValue(comparison) {
      return (value) => {
        if (!comparison || !value) return true;
        const floatValue = this.parseValueToFloat(`${value}`.replace('.', ','));
        if (floatValue > comparison) {
          return this.$t('support.components.inputs.mustBeLesserThan',
            { num: comparison });
        }
        return true;
      };
    },
  },
};
</script>
<style lang="stylus" scoped>
  .parameter-table
    .text-body-small-regular
      font-style normal
      font-weight normal
      font-size 14px
      line-height 99px
      color #424242
</style>
